import { UNLICENSED } from '@jira/platform__application-editions/src/edition.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { functionWithCondition } from '@atlassian/jira-feature-flagging-utils';
import { useIsAdmin } from '@atlassian/jira-tenant-context-controller/src/components/is-admin/index.tsx';
import { useApplicationPermissions } from '@atlassian/jira-tenant-context-controller/src/components/application-permissions/index.tsx';
import { useAppEditions } from '@atlassian/jira-tenant-context-controller/src/components/app-editions/index.tsx';

export const useShowCustomerServiceOld = (): boolean => {
	const isAdmin = useIsAdmin();
	const { hasServiceDeskAccess } = useApplicationPermissions();

	return fg('jcs_master_flag') && (isAdmin || hasServiceDeskAccess);
};

export const useShowCustomerServiceNew = (): boolean => {
	const { hasCustomerServiceAccess } = useApplicationPermissions();
	const { customerService } = useAppEditions();

	if (!fg('jcs_master_flag') || customerService === UNLICENSED) {
		return false;
	}

	return hasCustomerServiceAccess;
};

export const useShowCustomerService = functionWithCondition(
	() => fg('jcs_project_type_m3'),
	useShowCustomerServiceNew,
	useShowCustomerServiceOld,
);
